// chipListEdit — pure list-edit helpers behind the ChipsInput component
// (ENG-843 prefab trigger phrases). Kept out of React so the exact editing
// semantics (what Enter/comma/Backspace do to the array) are unit-testable.
//
// Semantics match the approved prototype:
//   - a committed value is trimmed, then a single trailing comma is stripped
//     (typing "hey there," commits "hey there")
//   - empty commits are ignored
//   - no dedupe: chips map 1:1 to jsonb array elements; duplicates are the
//     author's call
//   - Backspace with an empty input pops the LAST chip

/** Normalize a raw input commit: trim, strip one trailing comma, re-trim. */
export function normalizeChip(raw) {
  return String(raw ?? '').trim().replace(/,$/, '').trim()
}

/** Commit `raw` onto the list. Returns { list, added } — original list if empty. */
export function addChip(list, raw) {
  const v = normalizeChip(raw)
  if (!v) return { list, added: false }
  return { list: [...list, v], added: true }
}

/** Remove the chip at `index` (bounds-safe; out-of-range returns the list as-is). */
export function removeChipAt(list, index) {
  if (!Number.isInteger(index) || index < 0 || index >= list.length) return list
  return list.filter((_, i) => i !== index)
}

/** Remove the last chip (Backspace on an empty input). Empty list stays empty. */
export function popChip(list) {
  return list.length ? list.slice(0, -1) : list
}
